/* eslint-disable no-nested-ternary */
import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useNavigate, useParams } from 'react-router-dom'
import useSession from 'src/authentication/hooks/use-session'
import {
  fetchHydratedSchedule,
  fetchQuiz,
  selectHydratedScheduleStatus,
  selectSessionByID,
  progressResetted,
} from './live.slice'
import StepContent from './components/step-content'
import Stepper from './components/stepper'

export default () => {
  let dispatch = useAppDispatch()
  let navigate = useNavigate()
  let userSession = useSession()

  let scheduleStatus = useAppSelector(selectHydratedScheduleStatus)
  let { sessionID } = useParams()
  let session = useAppSelector(selectSessionByID(sessionID ?? ''))

  useEffect(() => {
    if (userSession?.boundTreeStatus === 'limited') {
      navigate('/self-paced')
    }
  }, [userSession])

  useEffect(
    () => () => {
      dispatch(progressResetted())
    },
    [],
  )

  useEffect(() => {
    if (scheduleStatus === 'uninitialized') {
      dispatch(fetchHydratedSchedule())
    }
  }, [scheduleStatus])

  useEffect(() => {
    if (session?.classQuizID) {
      dispatch(fetchQuiz(session?.classQuizID ?? ''))
    }
  }, [session?.classQuizID])

  return (
    <>
      <div className="container-fluid">
        <div className="grid grid-cols-12">
          <div className="col-span-12 p-3 md:col-span-9">
            <StepContent />
          </div>
          <div className="col-span-12 p-3 md:col-span-3">
            <Stepper />
          </div>
        </div>
      </div>
    </>
  )
}
